import { useCallback, useMemo, useState } from "react";
import useActiveWeb3React from "./useActiveWeb3React";
import { calculateGasMargin } from "../utils";
import { getStakePoolContract } from "../utils";
import { useGasPrice } from "../state/user/hooks";
import { useTransactionAdder } from "../state/transactions/hooks";

// returns a variable indicating the state of the approval and a function which approves if necessary or early returns
export function useStakePool() {
  const { chainId, library, account } = useActiveWeb3React();
  const gasPrice = useGasPrice();
  const addTransaction = useTransactionAdder();

  return useCallback(async (type, poolId, amount) => {
    const stakePoolContract = getStakePoolContract(library, account, poolId);
    const estimate =
      type === 1
        ? stakePoolContract.estimateGas.withdraw
        : stakePoolContract.estimateGas.deposit;
    const method =
      type === 1 ? stakePoolContract.withdraw : stakePoolContract.deposit;

    const args = [amount];
    const value = null;

    await estimate(...args, value ? { value } : {})
      .then((estimatedGasLimit) => {
        method(...args, {
          ...(value ? { value } : {}),
          gasLimit: calculateGasMargin(estimatedGasLimit),
          gasPrice,
        }).then((response) => {
          // setAttemptingTxn(false);

          addTransaction(response, {
            summary: type === 0 ? "Deposit" : type === 1 ? "Withdraw" : "Claim",
          });
        });
      })
      .catch((err) => {
        // setAttemptingTxn(false);
        // we only care if the error is something _other_ than the user rejected the tx
        if (err?.code !== 4001) {
          console.error(err);
        }
      });
  });
}
